import { render, staticRenderFns } from "./agree.vue?vue&type=template&id=68928179&scoped=true"
import script from "./agree.vue?vue&type=script&lang=js"
export * from "./agree.vue?vue&type=script&lang=js"
import style0 from "./agree.vue?vue&type=style&index=0&id=68928179&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68928179",
  null
  
)

export default component.exports